import React from "react";
import { Input, Button, Dropdown } from "antd";
import { SearchOutlined, ClearOutlined, PlusOutlined } from "@ant-design/icons";

const toolbarStyle = {
  display: "flex",
  gap: "10px",
  marginBottom: "20px",
  flexWrap: "wrap",
  alignItems: "center",
};

const clearBtnStyle = {
  backgroundColor: "#D97A07",
  color: "white",
  border: "none",
};
const addBtnStyle = { marginLeft: "auto", backgroundColor: "#0D2E4D" };

export default function SearchToolbar({
  search,
  onSearchChange,
  onClearFilter,
  addButtonLabel,
  onAdd,
  showAdd = true,
  extra,
  dropdownAdd,
}) {
  const renderAddButton = () => {
    if (!showAdd) return null;

    if (dropdownAdd) {
      return (
        <Dropdown menu={{ items: dropdownAdd.items }} placement="bottomRight">
          <Button
            type="primary"
            icon={dropdownAdd.icon || <PlusOutlined />}
            style={addBtnStyle}
          >
            {dropdownAdd.label || addButtonLabel || "Add"}
          </Button>
        </Dropdown>
      );
    }

    if (onAdd) {
      return (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onAdd}
          style={addBtnStyle}
        >
          {addButtonLabel || "Add"}
        </Button>
      );
    }

    return null;
  };

  return (
    <div style={toolbarStyle}>
      <Input
        placeholder="Keyword Search..."
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
        style={{ width: "300px" }}
      />
      <Button
        icon={<ClearOutlined />}
        onClick={onClearFilter}
        style={clearBtnStyle}
      >
        Clear filter
      </Button>
      {extra}
      {renderAddButton()}
    </div>
  );
}
